import { css } from 'styled-components';

export const text = (options = {}) => css`
  font-size: var(--text-${options.size || 200});
  line-height: calc(var(--text-${options.size || 200}) * 1.2);
  ${options.strong &&
  css`
    font-weight: 600;
  `}
`;
